import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { WasThisUsefulProvider } from './providers/was-this-useful-provider';
import { WasThisUsefulFeedbackTextComponent } from './was-this-useful-feedback-text/was-this-useful-feedback-text.component';
import { WasThisUsefulLoaderComponent } from './was-this-useful-loader/was-this-useful-loader.component';
import { WasThisUsefulNoComponent } from './was-this-useful-no/was-this-useful-no.component';
import { WasThisUsefulReasonsComponent } from './was-this-useful-reasons/was-this-useful-reasons.component';
import { WasThisUsefulResultComponent } from './was-this-useful-result/was-this-useful-result.component';
import { WasThisUsefulShareComponent } from './was-this-useful-share/was-this-useful-share.component';
import { WasThisUsefulUserCheckComponent } from './was-this-useful-user-check/was-this-useful-user-check.component';
import { WasThisUsefulComponent } from './was-this-useful.component';
export var WasThisUsefulComponentNgModule = module(baseModuleId + ".was-this-useful", [])
    .provider('wasThisUseful', WasThisUsefulProvider)
    .component('wasThisUseful', WasThisUsefulComponent)
    .component('wasThisUsefulFeedbackText', WasThisUsefulFeedbackTextComponent)
    .component('wasThisUsefulLoader', WasThisUsefulLoaderComponent)
    .component('wasThisUsefulNo', WasThisUsefulNoComponent)
    .component('wasThisUsefulReasons', WasThisUsefulReasonsComponent)
    .component('wasThisUsefulResult', WasThisUsefulResultComponent)
    .component('wasThisUsefulShare', WasThisUsefulShareComponent)
    .component('wasThisUsefulUserCheck', WasThisUsefulUserCheckComponent);
